import { Box } from "@mui/material";
import { Button, Typography } from "@platform/design-system";

interface SelectionActionsProps {
  onSelectAll: () => void;
  onClear: () => void;
  selectAllDisabled?: boolean;
  clearDisabled?: boolean;
}

const SelectionActions = ({
  onSelectAll,
  onClear,
  selectAllDisabled = false,
  clearDisabled = false,
}: SelectionActionsProps): React.JSX.Element => (
  <Box sx={{ display: "flex", alignItems: "center", mb: 2, mt: 2 }}>
    <Button
      variant="tertiary"
      size="sm"
      onClick={onSelectAll}
      disabled={selectAllDisabled}
    >
      Select All
    </Button>
    <Typography sx={{ ml: 1 }} color="textSecondary">
      -
    </Typography>
    <Button
      variant="tertiary"
      size="sm"
      onClick={onClear}
      disabled={clearDisabled}
    >
      Clear
    </Button>
  </Box>
);

export default SelectionActions;
